import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { Link } from "react-router-dom";
import Enter from './Enter'
import Button from '../Button'

@inject("CheckInStore")
@observer
class CheckInButton extends Component {
  render() {
    const { CheckInStore } = this.props;

    return (
      <div className={`${this.props.base}__section-area`}>
        {this.props.CheckInStore.isSubmitted ? (
          window.location.pathname === "/check-in" ? (
            <Fragment>
              <div style={{ marginBottom: "20px" }}>
                  <Button 
                    onClick={(e) => {
                      e.preventDefault()
                      CheckInStore.resetCheckInData()
                    }}
                    content={'Check in another rider'}
                    id={'check-in-next'}
                  />
              </div>
              <div>
                <Link to="/" style={{ fontWeight: "600" }}>
                  <div className="display--flex">
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20">
                          <g fill="none" fillRule="evenodd" id="svg--go-back">
                              <path fill="#F4F4F4" d="M-459-548H981V476H-459z"/>
                              <path fill="#000" fillRule="nonzero" d="M20.051 14.25c-1.115 2.398-3.076 4.207-5.52 5.096a9.503 9.503 0 0 1-3.248.573 9.603 9.603 0 0 1-7.111-3.173.767.767 0 0 1 .038-1.067.724.724 0 0 1 1.041.039c2.24 2.465 5.688 3.33 8.788 2.206 4.28-1.556 6.527-6.388 5.008-10.772C17.53 2.768 12.813.468 8.532 2.022a8.243 8.243 0 0 0-4.744 4.456l3.57-1.298a.734.734 0 0 1 .941.46.76.76 0 0 1-.448.963l-5.1 1.853a.72.72 0 0 1-.564-.03.748.748 0 0 1-.377-.429L.096 3.047a.76.76 0 0 1 .449-.963.733.733 0 0 1 .94.459l1.068 3.085C3.657 3.284 5.597 1.486 8.04.599c5.045-1.834 10.607.88 12.396 6.049a10.1 10.1 0 0 1-.385 7.601z"/>
                          </g>
                      </svg>
                    </div>
                    <div>
                      <span style={{ fontSize: "18px", marginLeft: "10px" }}>Back to rider overview</span>
                    </div>
                  </div>
                </Link>
              </div>
            </Fragment>
          ) : (
            <Link to="/">
              <Button content={'Back to Rider Overview'}/>
            </Link>
          )
        ) : (
          <Fragment>
            {CheckInStore.currentPage === 3 ? (
              <div className="button-container">
                <Button 
                  onClick={this.props.handleSubmit}
                  disabled={this.props.CheckInStore.isDisabled()}
                  content={'Submit'}
                />
                <Enter />
              </div>
            ) 
              : 
              CheckInStore.currentPage === 1 || CheckInStore.currentPage === 2 ? 
                !CheckInStore.isReturn ? (
                  <div className="button-container">
                    <Button 
                      onClick={this.props.handleNext}
                      disabled={this.props.CheckInStore.isDisabled()}
                      content={'Next'}
                    />
                    <Enter />
                  </div>
                )
                : (
                  <div className="button-container">
                    <Button 
                      onClick={this.props.handleReturns}
                      disabled={this.props.CheckInStore.isDisabled()}
                      content={'Submit'}
                    />
                    <Enter />
                  </div>
                )

              : null
          }
          </Fragment>
        )}
      </div>
    );
  }
}

export default CheckInButton;



// WEBPACK FOOTER //
// ./src/components/checkIn/CheckInButton.js